export class ArrayUtils {
    public static cloneMatrix(input: any[][]): any[][] {
        const result = [];
        for (let column of input) {
            result.push([...column]);
        }

        return result;
    }

    public static initArrayWithValues<T>(length: number, creator: (index: number) => T): T[] {
        const array: T[] = [];
        for (let i: number = 0; i < length; i++) {
            array.push(creator(i));
        }
        return array;
    }
}